var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabaseStorage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "database_server",
    "data-name": "database server"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m43.82 20.01a2.986 2.986 0 0 0 -2.82-2.01h-1v-2h1a3.009 3.009 0 0 0 3-3v-8a3.009 3.009 0 0 0 -3-3h-36a3.009 3.009 0 0 0 -3 3v8a3.009 3.009 0 0 0 3 3h1v2h-1a3.009 3.009 0 0 0 -3 3v8a3.009 3.009 0 0 0 3 3h1v2h-1a3.009 3.009 0 0 0 -3 3v8a3.009 3.009 0 0 0 3 3h19v8c0 3.94 9.56 6 19 6s19-2.06 19-6v-30c0-3.83-9.01-5.87-18.18-5.99zm-38.82-6.01a1 1 0 0 1 -1-1v-8a1 1 0 0 1 1-1h36a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1zm33 2v2h-4v-2zm-6 0v2h-18v-2zm-20 0v2h-4v-2zm12 30h-19a1 1 0 0 1 -1-1v-8a1 1 0 0 1 1-1h19zm-16-12v-2h4v2zm16 0h-10v-2h10zm0-8v4h-19a1 1 0 0 1 -1-1v-8a1 1 0 0 1 1-1h36a.7.7 0 0 1 .14.03c-8.8.25-17.14 2.29-17.14 5.97zm36 30c0 1.36-6 4-17 4s-17-2.64-17-4v-7.18c3.29 2.09 10.16 3.18 17 3.18s13.71-1.09 17-3.18zm0-10c0 1.36-6 4-17 4s-17-2.64-17-4v-7.18c3.29 2.09 10.16 3.18 17 3.18s13.71-1.09 17-3.18zm0-10c0 1.36-6 4-17 4s-17-2.64-17-4v-7.18c3.29 2.09 10.16 3.18 17 3.18s13.71-1.09 17-3.18zm-17-6c-11 0-17-2.64-17-4s6-4 17-4 17 2.64 17 4-6 4-17 4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m42 35h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m42 46h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m42 55h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m11 22h-4a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-2v-2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m19 22h-4a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-2v-2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m11 6h-4a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-2v-2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m19 6h-4a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-2v-2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m22 6h14v2h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m38 6h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m22 10h14v2h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m38 10h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m11 38h-4a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-2v-2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m19 38h-4a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-2v-2h2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseStorage);
export default __webpack_public_path__ + "static/media/database-storage.eb71ad4a159ec441c6f1c611aa67563c.svg";
export { ForwardRef as ReactComponent };